'use client'

import { useState } from 'react'

import { Divider, Drawer, Badge, Typography } from 'antd'
import { Button, SideFilter } from '@/src/components'

import '@fortawesome/fontawesome-svg-core/styles.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '@/src/lib'

import { QueryStringParams } from '@/src/interfaces'

const { Text } = Typography

const BADGE_STYLES = {
  active: '#ff4d4f',
  inactive: '#d9d9d9',
} as const

export const FiltersDrawer = ({
  activeFiltersCount,
  searchParams,
  setSearchParams,
}: {
  activeFiltersCount: number
  searchParams: QueryStringParams
  setSearchParams: (params: QueryStringParams) => void
}) => {
  const [open, setOpen] = useState(false)

  const showDrawer = () => {
    setOpen(true)
  }

  const onClose = () => {
    setOpen(false)
  }

  const BadgeCount = ({
    activeFiltersCount,
  }: {
    activeFiltersCount: number
  }) => {
    return (
      <Badge
        count={activeFiltersCount}
        showZero
        style={{
          marginLeft: 8,
          backgroundColor:
            activeFiltersCount === 0
              ? BADGE_STYLES.inactive
              : BADGE_STYLES.active,
        }}
      />
    )
  }
  return (
    <div className='flex justify-center items-center'>
      <div className='hidden lg:flex w-full lg:w-auto justify-between items-center whitespace-nowrap my-4 md:my-0'>
        <Text className='inline-flex items-center'>
          <FontAwesomeIcon icon='sliders' className='mr-2' />
          All Filters
          <BadgeCount activeFiltersCount={activeFiltersCount} />
        </Text>
      </div>

      <div className='block lg:hidden'>
        <Button
          onClick={showDrawer}
          icon='sliders'
          text={
            <>
              All Filters
              <BadgeCount activeFiltersCount={activeFiltersCount} />
            </>
          }
        />
        <Divider type='horizontal' style={{ margin: '0px' }} />
      </div>
      <Drawer
        title='All Filters'
        onClose={onClose}
        open={open}
        placement={'bottom'}
      >
        <SideFilter
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      </Drawer>
    </div>
  )
}
